angular.module('content.widgets.contentWidget', [
  'content.widgets.ContentWidgetController'
])

/**
 * The contentWidget provides a preview
 * of the contentWidget item type
 *
 * @class ContentWidget
 * @constructor
 * @module content.widgets.contentWidget
 * @example
 *   <content-widget
 *     model="form.model">
 *   </content-widget>
 */
.directive('contentWidget', [
  '$state',
  function ($state) {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        if ($state.params.widgetMode === 'edit' || $state.params.stateMode === 'edit') {
          return 'content/source/content/widgets/contentWidget/content-widget-edit.html';
        }
        return 'content/source/content/widgets/contentWidget/content-widget.html';
      },
      controller: 'ContentWidgetController'
    };
  }
]);
